import React, { useState } from 'react'
import { logoGreenImageUrl, arrowImageUrl } from '../assets'
import { Iconfont } from '../components/Icon'
import API from '../apis'

const parts = [
  {
    icon: <Iconfont name="twitter" />,
    title: 'Twitter',
    link: 'https://twitter.com/Sandbags_io',
  },
  {
    icon: <Iconfont name="discord" />,
    title: 'Discord',
    link: 'https://discord.gg/m7q77kSYyw',
  },
  {
    icon: <Iconfont name="github" />,
    title: 'Github',
    link: 'https://github.com/sandbags-protocol',
  },
  {
    icon: <Iconfont name="document" />,
    title: 'Document',
    link: 'https://docs.sandbags.io/',
  },
  {
    icon: <Iconfont name="medium" />,
    title: 'Medium',
    link: 'https://medium.com/@Sandbags_io',
  },
  {
    icon: <Iconfont name="email" />,
    title: 'Email',
    link: 'mailto:admin@sandbags.io',
  },
]

const emailReg = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/gi

interface Alert {
  type: 'error' | 'success'
  message: string
}

const Footer: React.FC = () => {
  const [email, setEmail] = useState('')
  const [alert, setAlert] = useState<Alert | null>(null)
  const handleAlert = (alert: Alert): void => {
    setAlert(alert)
    setTimeout(
      () => {
        setAlert(null)
      },
      alert.type === 'error' ? 3000 : 1000
    )
  }

  const handleSubscribe = (): void => {
    if (!emailReg.test(email)) {
      handleAlert({
        type: 'error',
        message: 'Please enter a valid email address',
      })
      return
    }
    API.subscribe(email)
      .then(() => {
        handleAlert({
          type: 'success',
          message: 'Thank you!',
        })
      })
      .catch(() => {})
  }

  return (
    <footer>
      <div className="container">
        <div className="info">
          <div className="logo">
            <img src={logoGreenImageUrl} alt="" />
          </div>
          <div className="contracts">
            <div className="subtitle">Contact Us</div>
            <div className="list">
              {parts.map((part, i) => (
                <a
                  className="contract"
                  href={part.link}
                  target="_blank"
                  key={i}
                >
                  {part.icon}
                  <span>{part.title}</span>
                </a>
              ))}
            </div>
          </div>
          <div className="submit">
            <div className="subtitle">Subscribe</div>
            <div className="t">
              {
                "Leave your email and we'll make sure you're in the know of everything that matters!"
              }
            </div>
            <div className="form">
              <input
                type="text"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button
                onClick={handleSubscribe}
                style={{ backgroundImage: `url(${arrowImageUrl})` }}
              />
              {alert && (
                <div className={`alert glass-bg ${alert.type}`}>
                  {alert.message}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="rights">
          <span>
            {'Copyright © Sandbags Protocol. 2022. All rights reserved.'}
          </span>
          <span>
            {'Theme inspired by '}
            <a href="https://github.com/ykob" target="_blank">
              ykob
            </a>
            {'.'}
          </span>
        </div>
      </div>
    </footer>
  )
}

export default Footer
